import type { RouteLocationNormalized, RouteLocationRaw } from 'vue-router';
import { useCommunicationKitStore } from '@client/feature/communication-kit/application/store/communication-kit.store';
import { CommunicationKitRouteName } from '@client/feature/communication-kit/application/routes/communication-kit.route-name';

export function checkCommunicationKitTemplateSelected(to: RouteLocationNormalized): true | RouteLocationRaw {
  const templateId = typeof to.params.templateId === 'string' ? to.params.templateId : null;
  if (!templateId) {
    return { name: CommunicationKitRouteName.Template };
  }

  const communicationKitStore = useCommunicationKitStore();
  communicationKitStore.setSelectedTemplateId(templateId);

  return true;
}
